// export function debounce(callback, timeoutThreshold) {
//   let timeout;
//   let context;
//   return function (...args) {
//     context = this;
//     if (timeout) {
//       window.clearTimeout(timeout);
//     }
//     timeout = window.setTimeout(function () {
//       timeout = 0;
//       callback.apply(context, args);
//     }, timeoutThreshold);
//   };
// }

// export const delay = (time) => new Promise((res) => setTimeout(res, time));

// export function throttle(callback, timeoutThreshold) {
//   let calledCount = 0;
//   let context;
//   return function (...args) {
//     calledCount++;
//     if (calledCount === 1) {
//       context = this;
//       callback.apply(context, args);

//       setTimeout(function () {
//         if (calledCount > 1) {
//           callback.apply(context, args);
//         }
//         calledCount = 0;
//       }, timeoutThreshold);
//     }
//   };
// }

// const params = {
//   mobile: false,
//     pad: false,
//     hardwareMobile: false,
// };
// function initParams() {
//   params.mobile = window.innerWidth <= 768;
//   const width = window.innerWidth;
//   const orientation =
//     (screen.orientation || {}).type ||
//     screen.mozOrientation ||
//     screen.msOrientation;
//   params.pad =
//     width > 768 &&
//     width <= 1024 &&
//     (orientation === "portrait-secondary" ||
//           orientation === "portrait-primary");
//     params.hardwareMobile = (navigator.platform ? "win16|win32|win64|mac|macintel".indexOf(navigator.platform.toLowerCase()) < 0 : false);
// }

// const initParamsDebounce = debounce(initParams, 500);
// window.addEventListener("resize", initParamsDebounce);
// window.addEventListener("orientationchange", initParamsDebounce);
// initParams(); // run at once

// export function isMobile() {
//   return params.mobile;
//   //   return window.innerWidth <= 768;
// }

// export function isPad() {
//   return params.pad;
//   //   var width = window.innerWidth;
//   //   var orientation =
//   //     (screen.orientation || {}).type ||
//   //     screen.mozOrientation ||
//   //     screen.msOrientation;
//   //   return (
//   //     width > 768 &&
//   //     width <= 1024 &&
//   //     (orientation === "portrait-secondary" || orientation === "portrait-primary")
//   //   );
// }

// export const isHardwareMobile = () => {
//     return params.hardwareMobile;
//     // var filter = "win16|win32|win64|mac|macintel";
//     // if( navigator.platform  ){
//     //     if( filter.indexOf(navigator.platform.toLowerCase())<0 ){
//     //         return true;
//     //     } else {
//     //         return false;
//     //     }
//     // }
// }





export const isMobile = () => {
  return window.innerWidth <= 768
}

export const isPad = () => {
  var width = window.innerWidth;
  var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
  return width > 768 && width <=1024 && (orientation === "portrait-secondary" || orientation === "portrait-primary");
}

export const isHardwareMobile = () => {
  var filter = "win16|win32|win64|mac|macintel";
  if( navigator.platform  ){
      if( filter.indexOf(navigator.platform.toLowerCase())<0 ){
          return true;
      } else {
          return false;
      }
  }
}

/**
 * @param {HTMLElement|string} elOrSelector 
 * @returns {HTMLElement}
 */
export function resolveElement(elOrSelector) {
  return typeof elOrSelector === 'string' ? document.querySelector(elOrSelector) : elOrSelector;
}

/**
 * @param {EventTarget|string} eventTargetOrSelector 
 * @param {string} eventName 
 * @param {EventListener} handler
 * @param {EventListenerOptions} options 
 * @returns {() => void}
 */
export function listen(eventTargetOrSelector, eventName, handler, options) {
  const target = resolveElement(eventTargetOrSelector);

  target.addEventListener(eventName, handler, options);

  return () => target.removeEventListener(target, eventName, handler, options);
}

const cacheSelectOneCache = []

/**
 * @param {string} selector 
 * @param {Element} [parent]
 * @returns {Element|null}
 */
export function cacheSelectOne(selector, parent) {
  let el = cacheSelectOneCache.find((cache) => cache.selector === selector && cache.parent === selector)

  if (!el) {
    el = (parent || document).querySelector(selector)
    cacheSelectOneCache.push({ selector, parent, el })
  }

  return el;
}

export function isLandscape() {
  if (window.screen?.orientation?.type) {
    isLandscape = () => {
      // 세로임에도 Orientation 이 landscape 로 포착되는 케이스 발견. 가로 세로값 한번 더 체크 후 최종 결정.
      return !['portrait-primary', 'portrait-secondary'].includes(screen.orientation.type) && window.innerWidth > window.innerHeight;
    }
  } else {
    isLandscape = () => {
      // return window.innerWidth > window.innerHeight;
      return window.matchMedia("(orientation: landscape)").matches;
    }
  }

  return isLandscape();
}

export function debounce(fn, duration) {
  return function (...args) {
    const context = this;
    let timeout;

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      timeout = 0;
      fn.apply(context, args);
    }, duration);
  }
}
